import PendingPage from '@totem/components/internalOnly/netSuitePending/PendingPage';
import SalesOrderDetailPage from '@totem/components/salesOrders/details/SalesOrderDetailPage';
import SalesOrdersPage from '@totem/components/salesOrders/list/SalesOrdersPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const contractRoutes: Route[] = [
  {
    path: 'salesOrders',
    pageTitle: 'Sales Orders',
    component: SalesOrdersPage,
    exact: true,
    breadcrumbs: [{ label: 'Sales Orders' }],
    render: (userProfile: UserProfile) =>
      permissions.contractsViewer.hasPermissions(userProfile),
  },
  {
    path: 'salesOrder/:salesOrderNumber',
    pageTitle: 'Sales Order',
    component: SalesOrderDetailPage,
    exact: true,
    breadcrumbs: [
      { label: 'Sales Orders', link: '/dashboard/salesOrders' },
      { label: 'Sales Order' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.contractsViewer.hasPermissions(userProfile),
  },
  {
    path: 'pendingImports',
    pageTitle: 'NetSuite Pending Imports',
    component: PendingPage,
    exact: true,
    breadcrumbs: [{ label: 'Pending Imports' }],
    render: (userProfile: UserProfile) =>
      permissions.internalIBOrgContractManagement.hasPermissions(userProfile),
  },
];
